(function () {
  if (window.__siblingsSwatches) return;
  window.__siblingsSwatches = true;

  var tipEl = null;

  function getTip() {
    if (tipEl) return tipEl;
    tipEl = document.createElement('div');
    tipEl.className = 'siblings-tip';
    tipEl.setAttribute('role', 'tooltip');
    document.body.appendChild(tipEl);
    return tipEl;
  }

  function showTip(text, x, y) {
    if (!text) return;
    var t = getTip();
    t.textContent = text;
    t.style.left = x + 'px';
    t.style.top = y - 14 + 'px';
    t.classList.add('is-visible');
  }

  function hideTip() {
    if (tipEl) tipEl.classList.remove('is-visible');
  }

  function initShowAll(fieldset) {
    var btn = fieldset.querySelector('.siblings-show-all:not([data-ready])');
    var grid = fieldset.querySelector('.siblings-grid');
    if (!btn || !grid) return;

    btn.setAttribute('data-ready', '');
    btn.addEventListener('click', function () {
      var expanded = grid.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? btn.getAttribute('data-show-fewer') : btn.getAttribute('data-show-all');
      if (!expanded && fieldset.__applyOneRow) fieldset.__applyOneRow();
    });
  }

  // [data-one-row] fieldsets show exactly one row of swatches; how many fit is
  // recomputed per viewport width. The active color always stays visible.
  function initOneRow(fieldset) {
    if (!fieldset.hasAttribute('data-one-row')) return;
    var grid = fieldset.querySelector('.siblings-grid');
    var btn = fieldset.querySelector('.siblings-show-all');
    if (!grid) return;
    var items = [].slice.call(grid.querySelectorAll('.siblings-grid__item'));
    if (items.length < 2) return;

    var activeIndex = -1;
    items.forEach(function (item, index) {
      if (activeIndex === -1 && item.hasAttribute('data-active')) activeIndex = index;
    });

    function apply() {
      if (grid.classList.contains('is-expanded')) return;
      var itemWidth = items[0].getBoundingClientRect().width;
      var gridWidth = grid.clientWidth;
      if (!itemWidth || !gridWidth) return;
      var visible = Math.max(1, Math.floor((gridWidth + 0.5) / itemWidth));
      if (visible > items.length) visible = items.length;

      items.forEach(function (item, index) {
        var show = index < visible;
        if (activeIndex >= visible) {
          show = index < visible - 1 || index === activeIndex;
        }
        item.classList.toggle('siblings-grid__item--collapsed', !show);
      });

      if (btn) btn.hidden = visible >= items.length;
    }

    fieldset.__applyOneRow = apply;
    apply();

    var raf = null;
    window.addEventListener('resize', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        apply();
      });
    });
  }

  function initTooltips(fieldset) {
    if (fieldset.getAttribute('data-tip-ready')) return;
    fieldset.setAttribute('data-tip-ready', '');

    [].forEach.call(fieldset.querySelectorAll('a[title]'), function (a) {
      var text = a.getAttribute('title');
      if (!text) return;
      a.setAttribute('data-tip', text);
      a.setAttribute('aria-label', text);
      a.removeAttribute('title');
    });

    var tipEvent = null;
    var tipRaf = null;
    fieldset.addEventListener(
      'mousemove',
      function (e) {
        tipEvent = e;
        if (tipRaf) return;
        tipRaf = requestAnimationFrame(function () {
          tipRaf = null;
          if (!tipEvent) return;
          var target = tipEvent.target;
          var a = target && target.closest && target.closest('a[data-tip]');
          if (a) {
            showTip(a.getAttribute('data-tip'), tipEvent.clientX, tipEvent.clientY);
          } else {
            hideTip();
          }
        });
      },
      { passive: true }
    );

    fieldset.addEventListener('mouseleave', function () {
      tipEvent = null;
      if (tipRaf) {
        cancelAnimationFrame(tipRaf);
        tipRaf = null;
      }
      hideTip();
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var fieldsets = scope.querySelectorAll('.product-form__input--siblings:not([data-siblings-ready])');

    fieldsets.forEach(function (fieldset) {
      fieldset.setAttribute('data-siblings-ready', '');
      initShowAll(fieldset);
      initTooltips(fieldset);
      initOneRow(fieldset);
    });
  }

  function boot() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  if (typeof MutationObserver !== 'undefined') {
    var pending = false;

    function scheduleInit() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        init(document);
      });
    }

    function containsSiblings(node) {
      if (node.nodeType !== 1) return false;
      return (
        (node.matches && node.matches('.product-form__input--siblings')) ||
        (node.querySelector && !!node.querySelector('.product-form__input--siblings'))
      );
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (containsSiblings(added[j])) {
            scheduleInit();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
